import { Cols } from "../shared/Consts";
import usePortfolio from "../hooks/PortfolioProvider";
import { usePath } from "../libs/path/PathProvider";
import PortUtils from "../portlibs/PortUtils";
import HoldingTable from "../components/widgets/HoldingTable";
import Holding from "../models/Holding";
import Toolbar from "../components/widgets/Toolbar";
import DateRangeFilter from "../components/widgets/DateRangeFilter";

function buildDivTotal(currency:number,holdings:Holding[],deposit:number){
    let holdingCost = 0, holdingValue = 0, gain = 0, dividend = 0, a_payout = 0, ytd_payout = 0, excessDiv = 0, n_payout = 0;
    for(let holding of holdings){
        const exchange = currency<0 ? holding.exchange : 1;
        holdingCost += holding.holdingCost * exchange;
        holdingValue += holding.holdingValue *exchange;
        gain += holding.gain * exchange;
        dividend += holding.dividend * exchange;
        a_payout += holding.a_payout * exchange;
        n_payout += holding.n_payout * exchange;
        excessDiv += holding.excessDiv * exchange;
        ytd_payout += holding.ytd_payout * exchange;
    }
    const yld = a_payout / holdingValue * 100;
    const holdingPercent = dividend / holdingCost * 100;
    const mwPercent = gain / deposit * 100
    const ret = {
        id: "total",
        holdingCost, holdingValue, gain, dividend, a_payout, ytd_payout, excessDiv, yield:yld, holdingPercent, n_payout,
        currency: currency<0 ? 0 : currency, mwPercent,
        value:(col:string) => PortUtils.cellValue(col, (ret as any)[col], {currency:0})
    }
    return ret
}

export default function DividendPage(){
    const {query} = usePath();
    const {account,currency,filter} = PortUtils.getFilter(query)
    const {portfolio} = usePortfolio()
    const cols = [Cols.name, Cols.holdingCost, Cols.holdingValue, Cols.quantity, Cols.payout, Cols.yield, Cols.a_payout, Cols.ytd_payout, Cols.n_payout, Cols.currentPrice, Cols.excessDiv, Cols.mwPercent];
    const rows = portfolio.filter(currency, filter, account, true).filter(holding => !holding.isCash && (!PortUtils.isZero(holding.quantity) || holding.ytd_payout>0))
    const footer = buildDivTotal(currency, rows, portfolio.getDeposits(account, currency))
    return <>
        <Toolbar><DateRangeFilter/></Toolbar>
        <div id="dividends" className="flex1 scroller">
            <HoldingTable tableName="divs" cols={cols} rows={rows} footer={footer}/>
        </div>
    </>

}